import { render, staticRenderFns } from "./SingularityDebugPanel.vue?vue&type=template&id=161e4544&"
import script from "./SingularityDebugPanel.vue?vue&type=script&lang=ts&"
export * from "./SingularityDebugPanel.vue?vue&type=script&lang=ts&"
import style0 from "./SingularityDebugPanel.vue?vue&type=style&index=0&id=161e4544&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports